import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  CopyOutlined,
  ExclamationCircleOutlined,
  StopOutlined,
} from '@ant-design/icons';
import { Tag } from 'antd';
import { lowerCase, startCase } from 'lodash';

import {
  Issuance,
  OfferDashboardDto,
  OfferLineItemMatch,
  SnapDisplayComment,
  SnapState,
  Transaction,
} from 'codegen';

const STATUSES = {
  ...SnapState,
  ...Issuance.status,
  ...Transaction.status,
  ...OfferDashboardDto.status,
  ...OfferLineItemMatch.status,
  ...SnapDisplayComment.resolutionStatus,
};

export const Status = ({ status }: { status?: keyof typeof STATUSES | string | null }) => {
  const formattedStatus = status ? startCase(lowerCase(status)) : '';

  if (status) {
    switch (status) {
      case 'DELETED':
      case STATUSES.ERROR:
      case STATUSES.DECLINED:
      case STATUSES.RECEIPT_EMPTY:
      case STATUSES.RECEIPT_INVALID:
      case STATUSES.RECEIPT_TOO_OLD:
      case STATUSES.RECEIPT_LOW_QUALITY:
      case STATUSES.RETAILER_NOT_ELIGIBLE:
      case STATUSES.RECEIPT_FRAUD:
        return (
          <Tag
            color='error'
            icon={<CloseCircleOutlined />}
          >
            {formattedStatus}
          </Tag>
        );
      case STATUSES.DUPLICATE_RECEIPT:
        return (
          <Tag
            color='error'
            icon={<CopyOutlined />}
          >
            {formattedStatus}
          </Tag>
        );
      case STATUSES.DISABLED:
      case STATUSES.REJECTED:
      case STATUSES.BACKED_OUT:
        return (
          <Tag color='error'>
            {formattedStatus}
          </Tag>
        );
      case STATUSES.UPCOMING:
        return (
          <Tag color='processing'>
            {formattedStatus}
          </Tag>
        );
      case STATUSES.MATCHING_SUCCESSFUL:
        return (
          <Tag
            color='processing'
            icon={<ClockCircleOutlined />}
          >
            {formattedStatus}
          </Tag>
        );
      case STATUSES.ISSUED:
      case STATUSES.CONFIRMED:
        return (
          <Tag
            color='success'
            icon={<CheckCircleOutlined />}
          >
            {formattedStatus}
          </Tag>
        );
      case STATUSES.ACTIVE:
      case STATUSES.SUCCESS:
      case STATUSES.FULL_MATCH:
      case STATUSES.MANUAL_MATCH:
        return (
          <Tag color='success'>
            {formattedStatus}
          </Tag>
        );
      case STATUSES.POTENTIAL_DUPLICATE:
      case STATUSES.CORRECTION_REQUIRED:
        return (
          <Tag
            color='warning'
            icon={<ExclamationCircleOutlined />}
          >
            {formattedStatus}
          </Tag>
        );
      case STATUSES.HELD:
      case STATUSES.BACKOUT:
      case STATUSES.PENDING:
      case STATUSES.EXPIRED:
      case STATUSES.MAX_RETRIES:
      case STATUSES.PARTIAL_MATCH:
        return (
          <Tag color='warning'>
            {formattedStatus}
          </Tag>
        );

      case STATUSES.NEW:
        return (
          <Tag className='bg-[white]'>
            {formattedStatus}
          </Tag>
        );
      case STATUSES.NO_MATCHED_OFFERS:
      case STATUSES.NO_MATCHED_PRODUCTS:
        return (
          <Tag icon={<StopOutlined />}>
            {formattedStatus}
          </Tag>
        );
      default:
        return (
          <Tag>
            {formattedStatus}
          </Tag>
        );
    }
  }

  return null;
};
